<template>
    <section class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
            </p>
        </div>

        <div class="row bar__container">
            <div class="col-md-6 py-0 mb-3 mb-md-0">
                <div class="input-field my-0" v-if="day_offs.length">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="col-4 col-md-2 py-0">
                <ul class="nav nav-tabs" v-if="day_offs.length">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#listation"> <i class="fa fa-list"/> </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#cards-listation">  <i class="fa fa-th-large"/> </a>
                    </li>
                </ul>
            </div>
            <div class="col-8 col-md-4 py-0">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="day_offs.length">
            <div class="tab-pane fade" id="cards-listation">
                <div class="row mb-0">
                    <div class="col-sm-6 col-lg-3" v-for="(value, i) in day_offs" :key="i">
                        <div class="row mb-0 no-gutters h-100">
                            <div class="col-12 card cardList hoverable">
                                <div class="card-content h-100">
                                    <div class="card-title">
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-10">
                                                <a href="#" @click="modal_update(i)" class="textTitleCard">
                                                    {{ `${i+1}. ${value.time_off}` }}
                                                </a>
                                            </div>
                                            <div class="col-2 text-right">
                                                <a href="#" @click="modal_deletion(i)">
                                                    <i class="material-icons prefix ">
                                                        <img class="iconCard" src="/assets/img/trash.png" alt="date">
                                                    </i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-0 no-gutters">
                                        <div class="col-12">
                                            <ul class="list">
                                                <li v-html="`${value.hours} Hours`" class="list__item"></li>
                                                <li v-html="`Start date: ${value.start_date}`" class="list__item"></li>
                                                <li v-html="`End date: ${value.end_date}`" class="list__item"></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="card-action right-align">
                                    <a :href="`#`" class="card-action__link">
                                        View more
                                    </a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <v-data-table
                                v-model="table_selection"
                                :headers="table_headers"
                                :items="day_offs"
                                :search="search"
                                :single-select="single_select"
                                item-key="id"
                                show-select
                                class="elevation-1"
                            >
                            </v-data-table>
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion_child(rest_api_child,$event)"
        />

        <FormModal 
            :title="'New Day Off'"
            :breadcrumb="breadcrumb"
            :parent_id="uncrypted_parent_id"
            :rest_api="rest_api_child"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Days off Update'"
            :breadcrumb="breadcrumb"
            :parent_id="uncrypted_parent_id"
            :rest_api="rest_api_child"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

    </section>
</template>

<script>
import axios            from    'axios';
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import Resources        from    './detail_resources'
import FormModal        from    './FormModal'
import UpdateModal      from    './UpdateModal'
import DeletionModal    from    '@/components/DeletionModal'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {

    name: 'AssociateChild',
    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal
    },

    data() {
        return {
            notyf,
            axios,
            parent:                 {},
            parent_id:              this.$route.params.id,
            uncrypted_parent_id:    '',
            title_page:             'Associate Day Off',
            rest_api:               `associates/${this.$route.params.id}`,
            rest_api_child:         `days_off`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            add_btn:                'Add Day off',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           '',
            single_object:          {},
            day_offs:               [],
            array_options:          {},
        }
    },

    methods: {

        unshift_object(new_object)
        {
            this.day_offs.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.day_offs.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.day_offs[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.day_offs[index]
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.parent                 =  data.associate
            this.uncrypted_parent_id    =  data.parent_id
            this.day_offs               =  data.day_offs
            this.array_options = {
                time_off_id:   data.time_offs
            }
            this.breadcrumb.push({
                name:   `${this.parent.first_name} ${this.parent.last_name}`,
                href:   '#',
                arrow:  "",
            })
        },

        trashing(index)
        {
            this.day_offs.splice(index, 1)
        }
    },
    
    async mounted()
    {
        await this.api_request()
    }
}

</script>
